
import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const useHonor = () => {
  const [honorData, setHonorData] = useState([]);

  useEffect(() => {
    axios.get(`${apiUrl}/api.php?endpoint=honorsummary`)
      .then(res => {
        const data = res.data;
        if (Array.isArray(data)) {
          setHonorData(data);
        } else {
          setHonorData([]);
        }
      })
      .catch(() => setHonorData([]));
  }, []);

  return { honorData };
};
